import { render } from "./PeriodManager.vue?vue&type=template&id=164c6aee&scoped=true"
import script from "./PeriodManager.vue?vue&type=script&lang=js"
export * from "./PeriodManager.vue?vue&type=script&lang=js"

import "./PeriodManager.vue?vue&type=style&index=0&id=164c6aee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164c6aee"]])

export default __exports__